/**
 * Returns the current environment set in the VITE_ENV variable.
 * Check whether there's 'VITE_ENV' on bitbucket-pipelines/.env.{{env}}
 * The value should be defined in the Repository variables.
 */
export const getEnv = () => import.meta.env.VITE_ENV;

export const getIsStageOrProdEnv = () => {
  const env = getEnv();
  return env === 'production' || env === 'stage';
};

export const getIsProdEnv = () => {
  const env = getEnv();
  return env === 'production';
};

export function isLocalhost() {
  return Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1',
  );
}
